import { PermissionCode } from '@/graphql/generated/types.generated';

// ─── Feature group ────────────────────────────────────────────────────────────

export interface FeatureGroup {
    label: string;
    codes: PermissionCode[];
}

export const FEATURED_CODES = [
    PermissionCode.Profiles,
    PermissionCode.WorkspaceMembers,
    PermissionCode.Competitors,
    PermissionCode.AndieCredits,
];

// Brand pricing: ProfilesGroups ("Brands") replaces Profiles as the featured add-on
export const BRAND_FEATURED_CODES = [
    PermissionCode.ProfilesGroups,
    PermissionCode.WorkspaceMembers,
    PermissionCode.Competitors,
    PermissionCode.AndieCredits,
    PermissionCode.ApiRequestsPerMonth,
    PermissionCode.McpToolsPerMonth,
];

// ─── Groupings for the "view all features" section ───────────────────────────

export const FEATURE_GROUPS: FeatureGroup[] = [
    {
        label: 'billing.calculator.group.team-workspace',
        codes: [PermissionCode.ProfilesGroups, PermissionCode.ApprovalWorkflow],
    },

    {
        label: 'billing.calculator.group.publishing',
        codes: [
            PermissionCode.MonthlyPosts,
            PermissionCode.PostsSchedule,
            PermissionCode.UploadSizeImages,
            PermissionCode.UploadSizeVideos,
            PermissionCode.FeedConnector,
            PermissionCode.FeedConnectorUpdateRate,
            PermissionCode.FeedConnectorAutoPublish,
            PermissionCode.XCredits,
        ],
    },
    {
        label: 'billing.calculator.group.analytics',
        codes: [
            PermissionCode.Dashboards,
            PermissionCode.DashboardsExports,
            PermissionCode.DashboardsSendSchedule,
            PermissionCode.DataHistory,
        ],
    },
    {
        label: 'billing.calculator.group.social-listening',
        codes: [PermissionCode.SocialListeningSources, PermissionCode.SocialListeningUpdateRate],
    },
    {
        label: 'billing.calculator.group.api-access',
        codes: [PermissionCode.ApiRequestsPerMonth, PermissionCode.McpToolsPerMonth],
    },
];

// Brand pricing: ProfilesGroups is featured, so strip it from the "Team & Workspace" group.
export const BRAND_FEATURE_GROUPS: FeatureGroup[] = [];
